<template>
  <div>
    <!-- 采购单详情 -->
    <div class="main-flag">
      <b></b>
      <span>招标单详情</span>
    </div>
    <!-- 物流信息 -->
    <div class="nave_table" v-if="status == 3 || status==4">
      <div class="nave_table_top">
        <p>物流信息</p>
      </div>
      <div class="nave_table_bottom1">
        <el-row>
          <el-col :span="24" class="info_content">
            <p>物流公司： {{ logistics_name }}</p>
            <p>运单号码： {{ info.logisticsNumber }}</p>
          </el-col>
          <el-col :span="24" v-if="deliver.length > 0">
            <el-collapse v-model="activeName" accordion class="getLogistics">
              <el-collapse-item title="查看物流" name="1">
                <el-steps direction="vertical" :active="1">
                  <el-step
                    icon="el-icon-position"
                    v-for="(deliverItem, index) in deliver"
                    :key="index"
                    :title="deliverItem.ftime"
                    :description="deliverItem.context"
                  ></el-step>
                </el-steps>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <!--  采购单信息-接口没有-->

    <!-- <div v-for="item1 in orderInfoList" :key="item1.code">
      <div class="nave_table">
        <div class="nave_table_top">
          <p>采购单概况</p>
        </div>
        <div class="nave_table_bottom1">
          <div>
            <p>采购单状态：{{ item1.status }}</p>
            <p>采购单单号：{{ item1.code }}</p>
            <p>采购人员{{ item1.projectName }}</p>
            <p>采购时间{{ item1.createTime }}</p>
            <p>审核人员{{ item1.isDel }}</p>
          </div>
          <el-row class="table_bottom">
            <el-col :span="18">审核时间{{ item1.createTime }}</el-col>
            <el-col :span="5">
              <el-button class="btns" type="primary">下单</el-button></el-col
            >
          </el-row>
        </div>
      </div>
    </div> -->
    <!-- 采购单信息 -->

    <div class="nave_table">
      <div class="nave_table_top">
        <p>招标单信息</p>
      </div>
      <div class="main">
        <el-row class="titlet">
          <el-col :span="4" v-if="typedata!==3">商品</el-col>
          <el-col :span="12" v-if="typedata==3">商品</el-col>
         <el-col :span="8" v-if="typedata!==3"  style="margin-left:20px">交货日期要求</el-col>
          <el-col :span="4">单价</el-col>
          <el-col :span="4">数量</el-col>
          <el-col :span="3">小计</el-col>
        </el-row>
        <el-row
          v-loading="loading"
          v-for="(item, index) in datalist"
          :key="index"
          class="itemlists"
        >
          <el-col :span="4" v-if="typedata!==3">
            <div class="itemtop">
              <el-image
                :src="'http://xyss.com.cn/no.png'"
                fit="fill"
                style="width: 100px; heigth: 100px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="name">
                <p>{{ item.productName }}</p>
            

                <p style="color: gary">{{ item.spec }}</p>
              </div>
            </div>
          </el-col>
            <el-col :span="12" v-if="typedata===3">
            <div class="itemtop">
              <el-image
                :src="'http://xyss.com.cn/no.png'"
                fit="fill"
                style="width: 100px; heigth: 100px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="name">
                 <p >{{ item.service }}</p>
                <p style="color: gary">{{ item.spec }}</p>
              </div>
            </div>
          </el-col>
            <el-col :span="8" v-if="typedata!==3">
            <p style="margin-left:20px">{{ item.latestDeliveryDate }}</p>
          </el-col>
          <el-col :span="4">
            <p>￥{{ item.price }}</p>
          </el-col>
          <el-col :span="4">
            <p>{{ item.number }}</p>
          </el-col>
          <el-col :span="4">
            <p>
              <span>￥{{ (item.price * item.number).toFixed(2) }}</span>
            </p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { SupplierorderDetails, getCompany, kuaidi100 } from "@/api/xunyou";
export default {
  data() {
    return {
      typedata:'',
      req: {
        oid: "",
      },
      activeName: "",
      loading: true,
      orderInfoList: [
        {
          address: "",
          addressDetail: null,
          area: "",
          attachment: "",
          city: "",
          code: "CG-6772020220114094104",
          contactPerson: "",
          createBy: null,
          createTime: "2022-01-14 09:41:04",
          desc: null,
          detailsList: null,
          id: 14,
          isDel: 0,
          mid: 134,
          params: {},
          phone: "",
          projectName: "3",
          province: "",
          quoteEndTime: null,
          quoteNum: 1,
          remark: null,
          searchValue: null,
          status: 2,
          title: "3",
          type: 1,
          updateBy: null,
          updateTime: "2022-01-14 11:41:01",
          userId: 411,
          visible: 0,
          winningMid: null,
        },
      ],
      deliver: [],
      info: {},
      logisticsCompany: "",
      datalist: [],
      logistics_name: "",
    };
  },

  /**
   * 创建完毕
   */
  created() {
    this.status = this.$route.query.status;
   
    this.handleData();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //查询数据
    handleData() {
      this.req.oid = this.$route.query.id;
      SupplierorderDetails(this.req).then((res) => {
        this.loading = false;
        this.datalist = res.data.orderInfoDetails;
        this.typedata=res.data.type
        this.info = res.data.info; //快递信息
        if (this.status == 3 ||this.status==4) {
          //状态为待收货时 已经收货才展示物流
          this.getCompanyLog(); //查询快递单号
        }
      });
    },
    //获取快递信息
    getCompanyLog() {
      getCompany({ id: this.info.logisticsCompany }).then((res) => {
        if (res) {
          this.logistics_code = res.code;
          this.logistics_name = res.name;
        }
        this.getTranspot();
      });
    },
    //   物流查询
    getTranspot() {
      kuaidi100({
        tracking_num: this.info.logisticsNumber,
        logistics_name: this.logistics_code, // 后续改成变量
      }).then((res) => {
        console.log(res, "res");
        this.deliver = res.data || [];
        this.logisticsNumber = res.nu;
        // this.logistics_name = res.com
        // })
      });
    },
  },
};
</script>
<style lang="less" scoped>
.itemlists {
  font-size: 16px;
  border-bottom: 1px dashed #eee;

  margin: 30px 5px;
  padding-top: 30px;
  p {
    margin-top: 10px;
    span {
      color: red;
    }
  }
  .itemtop {
    display: flex;

    .name {
      display: flex;
      flex-direction: column;
    }
  }
}
.nave_table {
  border: 1px solid gray !important;
  .nave_table_top {
    font-size: 14px;
    padding: 10px 10px;
    height: 40px;
    line-height: 40px;
    border: none !important;
    border-bottom: 1px solid gray !important;

    display: flex;
    align-items: center;
    background-color: #eef1f6;
    p {
      margin-right: 100px;
      color: gray;
      span {
        color: #000;
      }
    }
  }

  .main {
    padding: 20px;
    .titlet {
      color: gray;
      font-size: 16px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee !important;
    }
    //
  }
  .itembottom {
    font-size: 16px;
    margin-left: 600px;
    p {
      height: 40px;
      span {
        margin-left: 20px;
        color: red;
      }
    }
  }
  .nave_table_bottom1 {
    font-size: 14px;
    padding: 10px 10px;
    padding-bottom: 0;
    // border: 1px solid gray;
    p {
      height: 30px;
      line-height: 30px;
    }

    .table_bottom {
      height: 50px;
      line-height: 50px;
    }
    .btns {
      width: 150px;
    }
    .list {
      display: flex;
      flex-direction: column;
      p {
        height: 30px;
      }
      .Details {
        cursor: pointer;
      }
    }
    .last {
      margin-right: 30px;
      color: gray;
      cursor: pointer;
    }
  }
}

.nave_table {
  margin: 15px 0;
  .nave_table_top {
    font-size: 14px;
    padding: 5px 0px;
    border: 1px solid gray;
    border-bottom: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #eef1f6;
    p {
      padding: 0 20px;
      color: gray;
      span {
        margin: 0 10px;
        color: #000;
      }
    }
  }
}
.nave_content {
  display: flex;
  justify-content: space-around;
  height: 40px;

  align-items: center;
  background-color: #eef1f6;
}
.main-flag {
  margin-bottom: 20px;
  margin-left: 20px;
  b {
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #c6523f;
    vertical-align: middle;
  }
  span {
    font-weight: bold;
    font-size: 18px;
    padding-left: 8px;
    vertical-align: middle;
  }
}
// 查看物流
.getLogistics {
  border-top: 0px !important;
  border-bottom: 0px !important;
  /deep/.el-collapse-item__header {
    border-bottom: 0px !important;
    height: auto;
    line-height: inherit;
    color: #c65442;
    cursor: pointer;
    display: inline-block;
    margin: 10px 0;
  }
  /deep/.el-collapse-item__wrap {
    border-bottom: 0px !important;
  }
  /deep/.el-step__icon {
    height: auto;
  }
  /deep/.el-step__icon-inner[class*="el-icon"]:not(.is-status) {
    font-size: 10px;
  }
  /deep/.el-step.is-vertical .el-step__title {
    line-height: inherit;
    margin-top: 10px;
    font-weight: bold;
  }
  /deep/.el-step.is-vertical .el-step__icon.is-icon {
    margin-top: 20px;
  }
  /deep/.el-step__title.is-process,
  /deep/.el-step__description.is-process {
    color: #c0c4cc;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/myOrder/PurchaseOrderDetails.vue